import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface SelectionState {
  selectedItems?: string[];
}

const initialState: SelectionState = {};

const selectionSlice = createSlice({
  name: 'selection',
  initialState,
  reducers: {
    setSelectedItemsState(state, action: PayloadAction<string[]>) {
      state.selectedItems = action.payload;
    },
    clearSelectedItemsState(state) {
      state.selectedItems = [];
    }
  }
});

export const { setSelectedItemsState, clearSelectedItemsState } = selectionSlice.actions;
export default selectionSlice.reducer;
